import {
  LoadingTemplate,
  SiteAdminClinicInfoFormTemplate,
  SiteAdminNotFoundTemplate,
} from '@/components/templates';
import { useAdminClinicInfoCreate } from '@/hooks/admin';
import { useSiteAdminCopyClinicInfo } from '@/hooks/admin/useSiteAdminCopyClinicInfo';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ClinicCreateFormData, flattenClinicCreateData } from './clinicFormSchema';

const SiteAdminClinicInfoCopyPage = () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutateAsync: createClinicInfo, isPending } = useAdminClinicInfoCreate();

  const { data: clinicInfoData, isLoading, isError } = useSiteAdminCopyClinicInfo(id!);
  const clinicId = clinicInfoData?.data.clinic_id;

  const breadcrumbItems = [
    {
      title: '治療院詳細',
      href: clinicId
        ? `/${currentSite}/admin/clinics/${clinicId}`
        : `/${currentSite}/admin/clinics`,
    },
    {
      title: ':id',
    },
  ];

  const handleSubmit = async (data: ClinicCreateFormData) => {
    const flattenedData = flattenClinicCreateData(data);
    const finalClinicId = String(data.clinicInfo.clinic_id ?? '');
    await createClinicInfo({
      siteType: currentSite,
      data: {
        ...flattenedData,
        clinic_id: finalClinicId || null,
      },
    });
    if (finalClinicId) {
      queryClient.invalidateQueries({
        queryKey: ['clinic-detail', finalClinicId, currentSite],
      });
      navigate(`/${currentSite}/admin/clinics/${finalClinicId}`);
    }
  };

  if (isLoading) return <LoadingTemplate />;

  if (isError) return <SiteAdminNotFoundTemplate />;

  return (
    <main>
      <SiteAdminClinicInfoFormTemplate
        breadcrumbItems={breadcrumbItems}
        onSubmit={handleSubmit}
        isLoading={isPending}
        isCopy={true}
        clinicId={clinicId ? String(clinicId) : undefined}
        clinicInfoData={clinicInfoData?.data}
        site={currentSite}
      />
    </main>
  );
};

export default SiteAdminClinicInfoCopyPage;
